
//Blue button popup

import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Typography, Stack } from "@mui/material";
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close'
import PropTypes from 'prop-types'

export default function AlertDialog2({ title, message, btn_Blue_Text}) {
  // const [open, setOpen] = React.useState(false);

  const[close,setClose] = React.useState(true);
  // const handleClose = () => {
  //   setOpen(false);
  // };
  return (
    <div>
      
      <Dialog 
    // open={open}
    open={close}
    // onClose={() => setOpen(false)}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    // maxWidth='sm'
    maxWidth='md'
    sx={{
      color: '#ECF3FF'
    }}   
    >
    <DialogTitle id="alert-dialog-title" >
      <Stack direction={'row'} spacing={2}>
        <Typography variant={'h6'} sx={{flex:1,textAlign:'center', margin:"auto", ml:5 }} color={'primary'}>{title}</Typography>
        <IconButton color={'primary'} onClick={() => setClose(false)}>
          <CloseIcon/>
        </IconButton>
      </Stack>


    </DialogTitle>
    <DialogContent>
      <DialogContentText variant={'body1'} sx={{width:"60%", flex:1,textAlign:'center', margin:"auto" }} id="alert-dialog-description" >
    <br></br>
       {message}
      </DialogContentText>
    </DialogContent>
    <DialogActions sx={{paddingX: 3, paddingY: 2}}>
    {/* { btn_link && 
      <Button  
    
    variant={'text'}  align='right' sx={{paddingX: 3, textDecoration: "underline"}} size={'small'} onClick={() => setClose(true)}>
      {btn_link_text}
      </Button>} */}
      <Button  variant={'contained'} sx={{margin:"auto", width:"198px", backgroundColor: '#204488'}} size={'small'} onClick={() => setClose(false)}>
      {btn_Blue_Text}
      </Button>
     
    </DialogActions>
  </Dialog>
    </div>
  );
  
    }
// AlertDialog.propTypes = {
//   btn_link : PropTypes.bool
// }
// AlertDialog.defaultProps = {
//   btn_link : false
// };
